import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular-boost';
import { Observable } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';

type ErrorCallback = (err: string) => any;
type SuccessCallback = (data: any) => any;

@Injectable()
export class BillingService {
  // ------------------------------------------------------
  constructor(private apollo: Apollo) {}

  // ------------------------------------------------------
  public setField(
    billingId: string,
    fieldName: string,
    value: string,
    successfunction: SuccessCallback,
    errorfunction: ErrorCallback,
  ) {
    const input = {
      billingId,
      fieldName,
      value,
    };

    this.apollo
      .mutate({
        mutation: gql`
          mutation setBillingField($input: SetBillingFieldInput!) {
            setBillingField(input: $input) {
              error
            }
          }
        `,
        variables: { input: input },
      })
      .pipe(
        catchError(err => {
          if (errorfunction) {
            errorfunction(err);
          } else {
            console.log('Error: ');
            console.log(err);
          }
          return null;
        }),
      )
      .subscribe(result => {
        let data = result['data'].setBillingField;
        if (data.error) {
          if (errorfunction) {
            errorfunction(data.error);
          }
          return null;
        }

        if (successfunction) {
          successfunction(data);
        } else {
          console.log('Success');
        }
        return null;
      });
    return null;
  }
}
